// extracted by mini-css-extract-plugin
export default {"tabContainer":"HelpCenterTabContent_tabContainer__C2sWj","headerBlock":"HelpCenterTabContent_headerBlock__WnTAF"};